import { ImplementationMissingException, MUSTNeverHappenException } from '@nu-art/ts-common';
export class CollectionEntityMapper {
    static entities = [];
    static addEntities(newEntities) {
        if (newEntities.length === 0)
            return;
        this.entities = newEntities.reduce((toRet, currentEntity) => {
            const foundDuplicateEntityIndex = toRet.findIndex(entity => entity.type === currentEntity.type);
            if (foundDuplicateEntityIndex !== -1)
                throw new MUSTNeverHappenException(`The same collection entity with type '${toRet[foundDuplicateEntityIndex].type}', entityName '${toRet[foundDuplicateEntityIndex].entityName}'- is declared twice!`);
            toRet.push(currentEntity);
            return toRet;
        }, this.entities);
    }
    static getEntityMap(findFunction, entityIdentifier) {
        const foundEntity = CollectionEntityMapper.entities.find(findFunction);
        if (!foundEntity)
            throw new ImplementationMissingException(`Looking for entity with identifier '${entityIdentifier}', but such entity could not be found! Please verify such an entity is added to CollectionEntityMapper in the module packs.`);
        return foundEntity;
    }
    static getEntityMapByEntityName(entityName) {
        return CollectionEntityMapper.getEntityMap((ent) => ent.entityName === entityName, entityName);
    }
    static getEntityMapByCollectionName(collectionName) {
        return CollectionEntityMapper.getEntityMap((ent) => ent.type === collectionName, collectionName);
    }
}
//# sourceMappingURL=CollectionEntityMapper.js.map